<template>
  <div class="download-warning" :class="{static: isStatic}">
    <callout type="warning">
      <p>To ensure you are always working from the correct version please come back onto the intranet next time you need to use it. Using a {{type}} more than once? Simply star it to gain quicker access to it next time.</p>
    </callout>
  </div>
</template>

<script>
import Callout from "@/components/Containers/BaseCallout";
export default {
  name: "DownloadWarning",
  components: {
    Callout
  },
  props: {
    type: {
      type: String,
      default: "document"
    },
    isStatic: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped lang="scss">
.download-warning {
  position: fixed;
  width: 100%;
  z-index: 10;
  transition: all ease-in-out 0.3s;
  right: -100%;
  bottom: 20px;

  @media screen and (min-width: 1024px) {
    max-width: 500px;
  }

  &.show {
    right: 20px;
  }

  &.static {
    position: relative;
    right: auto;
    bottom: auto;
    margin: 20px 0;
    width: auto;
    display: block;
    max-width: 100%;;
  }
}
</style>